<template>
  <div class="navbar">
    <Topbar class="navbar-title" v-if="sidebarTopShow" />
    <p class="navbar-title" v-else>
      您好，觅特友工程行业共享互动信息平台欢迎您
    </p>
    <div class="right-menu">
      <!-- 我的积分 -->
      <router-link to="/shezhi/geren/account/integral">
        <div
          style="
            margin-right: 20px;
            color: #fff;
            height: 26px;
            background: #ffb300;
            line-height: 26px;
            border-radius: 20px;
            padding: 4px 20px;
            font-size: 16px;
            font-weight: bolder;
          "
        >
          积分：{{ !userVuexInfo ? 0 : parseInt(userVuexInfo.integral) }}
        </div>
      </router-link>
      <!-- 通知 -->
      <!-- <div class="right-menu-inform" @click="clickWarning">
        <i class="iconfont icon-lingdang"></i>
        <el-badge
          :value="warningNumber"
          :max="99"
          class="item"
          v-if="warningNumber * 1 > 0"
        >
        </el-badge>
      </div> -->
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <span style="margin-right: 10px">{{
            !userVuexInfo ? '--' : userVuexInfo.en_name
          }}</span>
          <img
            v-if="avatar && avatar != ''"
            :src="avatar"
            class="user-avatar"
          />
          <img v-else src="@/assets/images/photo.png" class="user-avatar" />
          <p>{{ getters.name }}</p>
          <p class="el-icon-caret-bottom"></p>
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <router-link to="/shezhi/geren/account/information">
            <el-dropdown-item> 资料管理 </el-dropdown-item>
          </router-link>
          <el-dropdown-item @click.native="logout">
            <span style="display: block">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters,mapState} from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import Topbar from "./Topbar";
import { getWarningCurrentWarning } from "@/api/index";
import { getToken } from "@/utils/auth";
import Cookies from "js-cookie";

export default {
  components: {
    Breadcrumb,
    Hamburger,
    Topbar,
  },
  data() {
    return {
      getters: {},
      warningNumber: 0, // 预警数量
      numberTimes: null,
      userInfo: {},
    };
  },
  computed: {
    ...mapGetters(["sidebar", "avatar", "name"]),
    ...mapState({
      userVuexInfo: state => state.user.userInfoData
     }),
    // userVuexInfo() {
    //   return this.$store.state.user.userInfoData;
    // },
    sidebarTopShow() {
      return this.$store.state.settings.sidebarTopShow;
    },
  },
  mounted() {
    // 和官网同步token
    this.settingCookies();
    this.getters = this.$store.getters;
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    // if (window.location.href.indexOf("localhost") != -1) {
    //   this.getWarningNumber();
    // } else {
    //   // 轮询接口
    //   this.numberTimes = setInterval(() => {
    //     // 获取预警待确认数量
    //     this.getWarningNumber();
    //   }, 5000);
    // }
  },
  methods: {
    // 和官网同步token
    settingCookies() {
      let type = process.env.VUE_APP_MEETYOU_EN_API;
      let token = getToken();
      if (type == "/api") {
        console.log("开发线");
        Cookies.set("vue_admin_website_token", token, {
          expires: 1000,
          path: "/",
          domain: "localhost",
        });
      } else if (type.indexOf(".dev.mty360.com") > 0) {
        console.log("测试线");
        Cookies.set("vue_admin_website_token", token, {
          expires: 1000,
          path: "/",
          domain: ".dev.mty360.com",
        });
      } else if (type.indexOf("mty360.com") > 0) {
        console.log("正式线");
        Cookies.set("vue_admin_website_token", token, {
          expires: 1000,
          path: "/",
          domain: ".mty360.com",
        });
      }
    },
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    async logout() {
      await this.$store.dispatch("user/logout").then((res) => {
        // 退出登陆删除官网token
        console.log(process.env.VUE_APP_MEETYOU_EN_API);
        let type = process.env.VUE_APP_MEETYOU_EN_API;
        if (type == "/api") {
          console.log("开发线");
          Cookies.set("vue_admin_website_token", "", {
            expires: 1000,
            path: "/",
            domain: "localhost",
          });
        } else if (type.indexOf(".dev.mty360.com") > 0) {
          console.log("测试线");
          Cookies.set("vue_admin_website_token", "", {
            expires: 1000,
            path: "/",
            domain: ".dev.mty360.com",
          });

          Cookies.set("vue_admin_company_token", "", {
            expires: 1000,
            path: "/",
            domain: ".dev.mty360.com",
          });
        } else if (type.indexOf("mty360.com") > 0) {
          console.log("正式线");
          Cookies.set("vue_admin_website_token", "", {
            expires: 1000,
            path: "/",
            domain: ".mty360.com",
          });

          Cookies.set("vue_admin_company_token", "", {
            expires: 1000,
            path: "/",
            domain: ".mty360.com",
          });
        }
        localStorage.removeItem("userInfo");
        localStorage.removeItem("vuex");
      });
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    },
    // 获取预警待确认数量
    getWarningNumber() {
      getWarningCurrentWarning()
        .then((res) => {
          this.warningNumber = res.data.count;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clickWarning() {
      // this.$router.push({
      //   path: "/monitoring/warning/list",
      // });
    },
  },
  // 离开页面之前清除定时器
  // beforeDestroy () {
  //   clearInterval(this.numberTimes);
  // }
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 60px;
  overflow: hidden;
  position: relative;
  background: #1677ff;
  color: #4b5768;
  margin-left: -20px;
  box-sizing: content-box;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 1002;
  &-title {
    flex: 1;
    font-size: 16px;
    color: #fff;
    overflow-y: scroll;
    overflow-y: hidden;
    margin-right: 20px;
  }
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 60px;
    display: flex;
    display: -webkit-flex;
    align-items: center;

    &:focus {
      outline: none;
    }
    &-inform {
      width: 60px;
      height: 60px;
      text-align: center;
      display: flex;
      display: -webkit-flex;
      align-items: center;
      color: #fff;
      justify-content: center;
      cursor: pointer;
      .icontongzhi:before {
        font-size: 20px;

        margin-top: 10px;
      }
      .el-badge {
        top: -7px;
        left: -5px;
      }
    }
    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      .avatar-wrapper {
        display: flex;
        display: -webkit-flex;
        align-items: center;
        position: relative;
        margin-right: 5px;
        color: #fff;
        cursor: pointer;

        .user-avatar {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          margin-right: 10px;
        }

        .el-icon-caret-bottom {
          width: 25px;
          height: 60px;
          line-height: 60px;
          font-size: 12px;
          text-align: center;
        }
      }
    }
  }
  &::v-deep {
    .el-badge__content {
      border: 0;
    }
  }
}
</style>
